import { NgModule } from '@angular/core';
import {
	ActivityInstructionsDialogComponent
} from '@go-modules/components/dialogs/activity-Instructions-dialog/activity-instructions-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { ActivityInfoModule } from '@go-modules/components/activity-info/activity-info.module';

@NgModule({
	imports: [
		TranslateModule,
		A11yModule,
		ActivityInfoModule
	],
	declarations: [
		ActivityInstructionsDialogComponent
	],
	exports: [
		ActivityInstructionsDialogComponent
	]
})
export class ActivityInstructionsDialogModule {}
